module.exports = __webpack_public_path__ + "img/buzon.1388a3bb.svg";